import { validateEmail } from './email'

function convertToSnakeCase(obj) {
  const newObj = {}
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase()
      newObj[newKey] = obj[key]
    }
  }
  return newObj
}

function generateSlug(item) {
  try {
    return item
      .toLowerCase() // Convert to lowercase
      .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
      .trim() // Trim leading/trailing spaces
      .replace(/\s+/g, '-') // Replace spaces with hyphens
      .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
  } catch (error) {
    return item
  }
}

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))

const delayWithCounter = (seconds, onTick) => {
  return new Promise(resolve => {
    let counter = seconds
    const interval = setInterval(() => {
      onTick(counter) // Update the UI or log the counter value
      counter -= 1
      if (counter < 0) {
        clearInterval(interval) // Stop the interval
        resolve() // Resolve the Promise when the counter finishes
      }
    }, 1000) // Execute every second
  })
}

const hasValue = param => {
  return param && param?.trim() !== ''
}

const decodeHtml = html => {
  if (!html) {
    return ''
  }

  const txt = document.createElement('textarea')
  txt.innerHTML = html
  let decoded = txt.value

  // Replace common HTML tags
  decoded = decoded.replace(/<br\s*\/?>/gi, '\n') // replace <br> with line break
  decoded = decoded.replace(/&nbsp;/gi, ' ') // just in case

  return decoded
}

const formatPrice = price => {
  if (!hasValue(price)) {
    return null
  }

  // Split the price into integer and decimal parts
  let [integerPart, decimalPart] = price.split('.')

  // Remove ".00" if there are no decimal values
  if (decimalPart === '00') {
    decimalPart = ''
  }

  // Add a dot after every thousand in the integer part
  integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, '.')

  // Combine the formatted integer and decimal parts
  let formattedPrice = integerPart
  if (decimalPart) {
    formattedPrice += ',' + decimalPart
  }

  return formattedPrice
}

export {
  validateEmail,
  convertToSnakeCase,
  generateSlug,
  delay,
  delayWithCounter,
  hasValue,
  formatPrice,
  decodeHtml,
}
